import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ["showState", "editState", "input", "form"];

  show(event) {
    event.stopPropagation();
    this.showStateTarget.classList.add('hidden');
    this.editStateTarget.classList.remove('hidden');

    // Only try to focus the input if it actually exists and is visible
    if (this.hasInputTarget && this.inputTarget.offsetParent !== null) {
      this.inputTarget.focus();
    } else {
      this.editStateTarget.focus();
    }
  }

  cancelIfClickedAway(event) {
    if (!this.element.contains(event.relatedTarget)) {
      this.cancel();
    }
  }

  save(event) {
    event.stopPropagation();
    event.preventDefault();

    // The component MUST have an input target to store the value for the form.
    if (!this.hasInputTarget) {
      console.error('ACTION ABORTED: The "inplace-edit" controller is missing its "input" target. Check that the data-inplace-edit-target="input" attribute is present on a form field within the controller\'s scope.');
      this.cancel();
      return;
    }

    const newValue = event.currentTarget.dataset.value ?? this.inputTarget.value;
    const oldValue = this.showStateTarget.dataset.value;

    // If the value hasn't changed, do nothing.
    if (newValue === oldValue) {
      this.cancel();
      return;
    }

    // Get field name and display values for the confirmation dialog
    const fieldName = this.showStateTarget.dataset.name || 'value';
    const oldDisplayValue = this.showStateTarget.textContent.trim();
    // For pickers, the display value is the text of the clicked element. For inputs, it's simply the new value.
    const newDisplayValue = (event.currentTarget === this.inputTarget) ? newValue : event.currentTarget.textContent.trim();

    const confirmationMessage = `You are about to change the ${fieldName} from "${oldDisplayValue}" to "${newDisplayValue}".\n\nAre you sure?`;

    // Show confirmation dialog and cancel if the user rejects.
    if (!window.confirm(confirmationMessage)) {
      this.cancel();
      return;
    }

    // Set the input's value for the form submission
    this.inputTarget.value = newValue;

    // Append the row's expanded state to the form so the controller can preserve it
    const row = this.element.closest('tr');
    if (row && this.hasFormTarget) {
      const expandButton = row.querySelector('.btn-expand');
      const isExpanded = expandButton ? expandButton.getAttribute('aria-expanded') : 'false';

      // Avoid adding the hidden input if it already exists from a previous save attempt
      let hiddenInput = this.formTarget.querySelector('input[name="is_expanded"]');
      if (!hiddenInput) {
        hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'is_expanded';
        this.formTarget.appendChild(hiddenInput);
      }
      hiddenInput.value = isExpanded;
    }

    // Submit the form using Rails UJS
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit();
    }
  }

  cancel(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.editStateTarget.classList.add('hidden');
    this.showStateTarget.classList.remove('hidden');
  }
}
